<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.showEmployee") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #26a1d6">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <!-- ==== Start:: Status Badges ==== -->
      <div class="badges_wrapper justify-content-end">
        <v-chip :color="data.is_active ? 'green' : 'red'" text-color="white">
          {{ data.is_active ? $t("STATUS.active") : $t("STATUS.notActive") }}
        </v-chip>
      </div>
      <!-- ==== End:: Status Badges ==== -->

      <!-- ==== Start:: Main Data ==== -->
      <form>
        <div class="row">
          <!-- Start:: Avatar Upload Input -->
          <base-image-upload-input
            col="6"
            identifier="avatar"
            :preSelectedImage="data.avatar"
            :placeholder="$t('PLACEHOLDERS.profileImage')"
            disabled
          />
          <!-- End:: Avatar Upload Input -->

          <!-- Start:: ID Image Upload Input -->
          <base-image-upload-input
            col="6"
            identifier="id_image"
            :preSelectedImage="data.id_image"
            :placeholder="$t('PLACEHOLDERS.idImage')"
            disabled
          />
          <!-- End:: ID Image Upload Input -->

          <!-- Start:: Employee Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.employeeName')"
            v-model.trim="data.name"
            disabled
          />
          <!-- End:: Employee Name Input -->

          <!-- Start:: Job Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.jobName')"
            v-model.trim="data.job_name"
            disabled
          />
          <!-- End:: Job Name Input -->

          <!-- Start:: mobile Input -->
          <base-phone-input
            col="6"
            v-model="data.mobile"
            @dialCode="dialCode"
            @isoCode="isoCode"
            :placeholder="$t('PLACEHOLDERS.phone')"
            :defaultCountry="data.iso_code"
            :key="phoneKey"
            disabled
          />
          <!-- End:: mobile Input -->

          <!-- Start:: ID Number Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.idNumber')"
            v-model.trim="data.id_number"
            disabled
          />
          <!-- End:: ID Number Input -->

          <!-- Start:: Birth Date Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.birthDate')"
            v-model="data.birth_date"
            disabled
          />
          <!-- End:: Birth Date Input -->

          <!-- Start:: Age Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.employeeAge')"
            v-model.trim="data.age"
            disabled
          />
          <!-- End:: Age Input -->

          <!-- Start:: Diseases Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.diseases')"
            v-model.trim="data.diseases"
            disabled
          />
          <!-- End:: Diseases Input -->

          <!-- Start:: Medications Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.medications')"
            v-model.trim="data.medications"
            disabled
          />
          <!-- End:: Medications Input -->

          <!-- Start:: Blood Type Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.bloodType')"
            v-model.trim="data.blood_type"
            disabled
          />
          <!-- End:: Blood Type Input -->

          <!-- Start:: Weight Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.weight')"
            v-model.trim="data.weight"
            disabled
          />
          <!-- End:: Weight Input -->

          <!-- Start:: Height Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.height')"
            v-model.trim="data.height"
            disabled
          />
          <!-- End:: Height Input -->

          <!-- Start:: Bank Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.bankName')"
            v-model.trim="data.bank_name"
            disabled
          />
          <!-- End:: Bank Name Input -->

          <!-- Start:: Account Number Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.accountNumber')"
            v-model.trim="data.account_number"
            disabled
          />
          <!-- End:: Account Number Input -->

          <!-- Start:: IBAN Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.ibanNumber')"
            v-model.trim="data.iban"
            disabled
          />
          <!-- End:: IBAN Input -->

          <!-- Start:: Created At Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.createdAt')"
            v-model.trim="data.created_at"
            disabled
          />
          <!-- End:: Created At Input -->

          <!-- Start:: Deactivate Reason (if exists) -->
          <base-input
            v-if="data.deactivate_reason"
            col="12"
            type="textarea"
            rows="3"
            :placeholder="$t('PLACEHOLDERS.deactivateReason')"
            v-model.trim="data.deactivate_reason"
            disabled
          />
          <!-- End:: Deactivate Reason -->
        </div>
      </form>
      <!-- ==== End:: Main Data ==== -->
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BasePhoneInput from "@/components/formInputs/BasePhoneInput.vue";

export default {
  name: "ShowEmployee",
  components: {
    BasePhoneInput,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      // Start:: Data
      data: {
        avatar: null,
        id_image: null,
        name: null,
        job_name: null,
        bank_name: null,
        mobile: null,
        dial_code: null,
        iso_code: null,
        id_number: null,
        birth_date: null,
        age: null,
        diseases: null,
        medications: null,
        blood_type: null,
        weight: null,
        height: null,
        account_number: null,
        iban: null,
        is_active: false,
        created_at: null,
        deactivate_reason: null,
      },
      phoneKey: 0,
      // End:: Data
    };
  },

  methods: {
    isoCode(iosCode) {
      this.data.iso_code = iosCode;
    },
    dialCode(dialCodeValue) {
      this.data.dial_code = dialCodeValue;
    },

    calculateAge() {
      if (this.data.birth_date) {
        const birthDate = new Date(this.data.birth_date);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (
          monthDiff < 0 ||
          (monthDiff === 0 && today.getDate() < birthDate.getDate())
        ) {
          age--;
        }

        this.data.age = age.toString();
      } else {
        this.data.age = null;
      }
    },

    // Start:: Get Data To Show
    async getDataToShow() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `clients/${this.id}`,
        });

        const employee = res.data.data.data;

        this.data.avatar = employee.avatar;
        this.data.id_image = employee.identity_image;
        this.data.name = employee.name;
        this.data.job_name = employee.job?.name;
        this.data.bank_name =
          employee?.user_info?.bank?.name || employee?.bank?.name;
        this.data.mobile = employee.mobile;
        // this.data.dial_code = employee?.country_code;
        // this.data.iso_code = employee?.iso_code;
        this.data.id_number = employee.identity_number;
        this.data.birth_date = employee.birth_date;
        this.data.diseases =
          employee?.user_info?.diseases || employee?.diseases;
        this.data.medications =
          employee?.user_info?.medications || employee?.medications;
        this.data.blood_type =
          employee?.user_info?.blood_type || employee?.blood_type;
        this.data.weight = employee?.user_info?.weight || employee?.weight;
        this.data.height = employee?.user_info?.height || employee?.height;
        this.data.account_number =
          employee?.user_info?.account_number || employee?.account_number;
        this.data.iban = employee?.user_info?.iban || employee?.iban;
        this.data.is_active = employee.is_active;
        this.data.created_at = employee.created_at;
        this.data.deactivate_reason = employee.deactivate_reason;

        this.calculateAge();
        this.phoneKey++;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Get Data To Show
  },

  async created() {
    await this.getDataToShow();
  },
};
</script>
